/**
 * Like
 */
class Like {
	constructor( $node: any ) {
		// constructor
	}
}

export default Like;
